export const showAnimation = {
  hidden: {
    width: 0,
    opacity: 0,
    transition: {
      duration: 0.5
    }
  },
  show: {
    opacity: 1,
    width: 'auto',
    transition: {
      duration: 0.2
    }
  }
}

export const iconAnimation = {
  hidden: {
    width: 0,
    opacity: 0,
    transition: {
      duration: 0.1
    }
  },
  show: {
    opacity: 1,
    width: 'auto',
    transition: {
      duration: 0.5
    }
  }
}

export const logoAnimation = {
  hidden: {
    opacity: 0,
    scale: 0.8
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4
    }
  }
}
